class CartTool extends HTMLElement {
  constructor() {
    super();
    const buttons = this.querySelectorAll('.cartTool-item');
    buttons.forEach((button) => {
      button.addEventListener('click',(event) => {
        const id = event.target.dataset.popup;
        document.getElementById(id).classList.add('show');
        document.querySelector('.previewCart').classList.add('active-tool');
      })
    })
  }
}

customElements.define('cart-item-tool', CartTool);

class CartCancel extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('button').addEventListener('click',(event) => {
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-cancel-popup', CartCancel);

class CartNote extends HTMLElement {
  constructor() {
    super();
    
    this.querySelector('[data-update-note]').addEventListener('click', (event) => {
      this.val = this.querySelector('.text-area').value;
      const body = JSON.stringify({ note: this.val });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      document.querySelector('.popup-toolDown.show').classList.remove('show');
      document.querySelector('.previewCart').classList.remove('active-tool');
    })
  }
}

customElements.define('cart-note', CartNote);

class CouponCode extends HTMLElement {
  constructor() {
    super();
    if (localStorage.getItem('storedDiscount')){
      this.querySelector('input[name="discount"]').value = localStorage.getItem('storedDiscount');  
    }
    this.querySelector('[data-update-coupon]').addEventListener('click', (event) => {
      this.val = this.querySelector('input[name="discount"]').value.trim();

      const discountCode = this.val || 'null';
      const applyBtn = event.currentTarget;
      
      // Show loading state on button
      const originalText = applyBtn.textContent;
      applyBtn.disabled = true;
      applyBtn.textContent = '...';

      // 每次重新请求时重置错误提示
      const noMatchEl = this.querySelector('.no-match-disct');
      if (noMatchEl) {
        noMatchEl.style.display = 'none';
      }

      fetch(`/discount/${discountCode}`)
        .then((response) => response.text())
        .then(() => {
          // /discount/{code} 始终返回 200，需通过购物车验证折扣是否真正生效
          return fetch('/cart.js').then((r) => r.json());
        })
        .then((cart) => {
          // 检查购物车级别折扣是否被接受（大小写不敏感）
          const appliedDiscounts = cart.cart_level_discount_applications || [];
          const discountApplied = appliedDiscounts.some(
            (d) => d.title?.toLowerCase() === discountCode.toLowerCase()
          );

          if (!discountApplied) {
            throw new Error('Invalid discount code');
          }

          // 仅在折扣码验证成功后才缓存
          localStorage.setItem('storedDiscount', this.val);

          // Try to close popup if it exists (for backward compatibility with popup mode)
          const showToolpop = document.querySelector('.popup-toolDown.show');
          if (showToolpop) {
            showToolpop.classList.remove('show');
          }
          const previewCart = document.querySelector('.previewCart');
          if (previewCart) {
            previewCart.classList.remove('active-tool');
          }

          // Update sidebar cart
          if (window.sharedFunctions?.updateSidebarCart) {
            window.sharedFunctions.updateSidebarCart(cart);
          }
        })
        .catch((error) => {
          console.error('Discount code application failed:', error);
          // Show error message
          const noMatchEl = this.querySelector('.no-match-disct');
          if (noMatchEl) {
            noMatchEl.style.display = 'block';
          }
        })
        .finally(() => {
          // Restore button state
          applyBtn.disabled = false;
          applyBtn.textContent = originalText;
        });
    })
  }
}

customElements.define('coupon-code', CouponCode);
